(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("5LBoh", function(module, exports) {
const $432e588a829d13cf$var$iframeWrapper = document.querySelector(".s-tickets__goout");
const $432e588a829d13cf$var$gooutUrl = $432e588a829d13cf$var$iframeWrapper?.dataset.gooutUrl;
const $432e588a829d13cf$var$tickets = document.querySelectorAll(".i-ticket[data-goout-id]");
const $432e588a829d13cf$var$gooutBlock = document.querySelector(".--js-goout-block");
const $432e588a829d13cf$var$GOUT_READY_EVENT_KEY = "gooutReady";
const $432e588a829d13cf$var$GOOUT = {
    init: function(callback) {
        const script = document.createElement("script");
        script.src = "https://partners.goout.net/framework/widgets-api.js";
        document.body.appendChild(script);
        window.addEventListener("goApiReady", callback);
    }
};
$432e588a829d13cf$var$GOOUT.init(function() {
    goOut.frame($432e588a829d13cf$var$iframeWrapper, $432e588a829d13cf$var$gooutUrl);
    document.dispatchEvent(new Event($432e588a829d13cf$var$GOUT_READY_EVENT_KEY));
});
const $432e588a829d13cf$var$handleGooutScroll = ()=>{
    if (!$432e588a829d13cf$var$gooutBlock) return;
    if (!$432e588a829d13cf$var$gooutBlock.classList.contains("--toggled")) $432e588a829d13cf$var$gooutBlock.classList.add("--toggled");
    $432e588a829d13cf$var$gooutBlock.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
    });
};
const $432e588a829d13cf$var$handleGooutMessage = (ticketId, ticketsCount)=>{
    const iframe = $432e588a829d13cf$var$iframeWrapper?.querySelector("iframe");
    if (!iframe || !iframe.contentWindow || !ticketsCount || !$432e588a829d13cf$var$gooutUrl) return;
    const message = {
        tickets: {
            [ticketId]: ticketsCount
        }
    };
    console.log(message);
    iframe.contentWindow.postMessage(message, $432e588a829d13cf$var$gooutUrl);
};
document.addEventListener($432e588a829d13cf$var$GOUT_READY_EVENT_KEY, ()=>{
    const currentUrl = new URL(window.location.href);
    const ticketId = Number(currentUrl.searchParams.get("ticketId"));
    const ticketCount = Number(currentUrl.searchParams.get("count") ?? 1);
    const iframe = document.querySelector(".goOutFrame");
    if (!ticketId || !iframe) return;
    iframe.onload = ()=>{
        function checkIfLoaded() {
            if (document.readyState === "complete") {
                $432e588a829d13cf$var$handleGooutScroll();
                $432e588a829d13cf$var$handleGooutMessage(ticketId, Number(ticketCount));
            } else setTimeout(checkIfLoaded, 500);
        }
        checkIfLoaded();
    };
});
if ($432e588a829d13cf$var$iframeWrapper) $432e588a829d13cf$var$tickets.forEach((ticket)=>{
    const buyButton = ticket.querySelector(".i-ticket__cta");
    const gooutTicketId = Number(ticket.dataset.gooutId);
    if (!buyButton || !gooutTicketId) return;
    buyButton.addEventListener("click", (e)=>{
        e.preventDefault();
        const counterInput = ticket.querySelector(".c-counter input");
        if (counterInput) {
            $432e588a829d13cf$var$handleGooutMessage(gooutTicketId, Number(counterInput.value));
            $432e588a829d13cf$var$handleGooutScroll();
        }
    });
});

});

})();
//# sourceMappingURL=tickets-section--goout.5d4fefcc.js.map
